import PropTypes from 'prop-types';
import { product } from './product';
import { author } from './author';
import { userAudiobook } from './user_audiobook';

export const audiobookProps = {
  abridged: PropTypes.bool,
  allAuthors: PropTypes.arrayOf(author),
  averageRating: PropTypes.number,
  coverUrl: PropTypes.string,
  currentBlurb: PropTypes.shape({
    sanitizedText: PropTypes.string,
  }),
  currentProduct: product,
  currentUserShoppingCartItem: PropTypes.shape({
    id: PropTypes.string,
  }),
  currentUserUserAudiobook: userAudiobook,
  currentUserWishlistItem: PropTypes.shape({
    id: PropTypes.string,
  }),
  description: PropTypes.string,
  displayAuthors: PropTypes.string,
  displayNarrators: PropTypes.string,
  displayTitle: PropTypes.string,
  publisher: PropTypes.string,
  runtime: PropTypes.string,
  futureSaleDate: PropTypes.string,
  id: PropTypes.string,
  ratingsCount: PropTypes.number,
  sampleUrl: PropTypes.string,
  url: PropTypes.string,
};

export const audiobook = PropTypes.shape(audiobookProps);
